export const deleteNullValues = (obj: any) => {
  Object.keys(obj).forEach((prop) => {
    if (obj[prop] === null) {
      delete obj[prop];
    }
  });
};
